var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9283 5.5788C19.7014 4.73538 19.0365 4.07051 18.1932 3.84341C16.6525 3.42188 10.49 3.42188 10.49 3.42188C10.49 3.42188 4.32768 3.42188 2.78707 3.82742C1.95999 4.05429 1.27878 4.7355 1.05191 5.5788C0.646484 7.11929 0.646484 10.3141 0.646484 10.3141C0.646484 10.3141 0.646484 13.5249 1.05191 15.0493C1.27902 15.8926 1.94376 16.5575 2.78719 16.7846C4.3439 17.2062 10.4902 17.2062 10.4902 17.2062C10.4902 17.2062 16.6525 17.2062 18.1932 16.8007C19.0366 16.5737 19.7014 15.9088 19.9286 15.0655C20.3339 13.5249 20.3339 10.3303 20.3339 10.3303C20.3339 10.3303 20.3501 7.11929 19.9283 5.5788ZM8.52797 13.2655V7.36262L13.6524 10.3141L8.52797 13.2655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeWhite);
export default __webpack_public_path__ + "static/media/YouTubeWhite.4c6afeadd25a508e0582ff0ec385e719.svg";
export { ForwardRef as ReactComponent };